import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.scss";
import Home from "./pages/Home/Home";
import ConsultorioAmor from "./pages/ConsultorioAmor/ConsultorioAmor";
import MainLayout from "./MainLayout";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="consultorio-del-amor" element={<ConsultorioAmor />} />
        </Route>
      </Routes>
    </Router>
  </React.StrictMode>,
);

reportWebVitals();
